import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../contexts";
import { useOverlayContext } from "../../../../contexts";
import { useOnMount } from "../../../../hooks/useOnMount";
import { CoverPageDesktop } from "./CoverPageDesktop";
import { CoverPageMobile } from "./CoverPageMobile";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetCoverPageTID = parentTestId => getTestIds({
  parentTestId
});
export const CoverPage = _ref => {
  let {
    testId,
    relationship,
    onGetStarted,
    isPreview,
    showRecipientToast
  } = _ref;
  const {
    CoverPageTestIds
  } = useMemo(() => GetCoverPageTID(testId), [testId]);
  const {
    isMobile
  } = useResponsive();
  const buyerName = "".concat(relationship.buyer.firstName || '', " ").concat(relationship.buyer.lastName || '').trim();
  const {
    showInfoToast
  } = useOverlayContext();
  useOnMount(() => {
    if (showRecipientToast) {
      showInfoToast("You're reviewing the proposal as ".concat(buyerName), CoverPageTestIds.RecipientToast());
    }
  });
  if (isMobile) {
    return /*#__PURE__*/_jsx(CoverPageMobile, {
      testId: testId,
      relationship: relationship,
      onGetStarted: onGetStarted,
      isPreview: isPreview
    });
  }
  return /*#__PURE__*/_jsx(CoverPageDesktop, {
    testId: testId,
    relationship: relationship,
    onGetStarted: onGetStarted,
    isPreview: isPreview
  });
};